<template>
  <div class="position-relative map__height">
    <GmapMap
      ref="mapRef"
      id="map"
      :center="center"
      :zoom="16"
      :options="mapOptions"
      map-type-id="terrain"
      style="width: 100%; height: 100%"
    >
      <GmapMarker
        :position="addressPosition"
        :clickable="false"
        :draggable="false"
        :icon="addressOption"
      />
      <GmapMarker
        v-for="(ent, index) in entrancePositionArr"
        :key="index"
        :position="ent"
        :clickable="false"
        :draggable="true"
        :icon="entranceOption"
        :label="getLabel(index)"
        @dragend="getCoordinates($event.latLng, index)"
      />
    </GmapMap>
  </div>
</template>

<script>
// import GmapCustomMarker from "vue2-gmap-custom-marker";
// import { bus } from "../main";
const entranceMarker = require("@/assets/images/custom__marker.png");
const locationMarker = require("@/assets/images/custom_marker_2.png");
export default {
  name: "Map",
  props: ["location", "entrance_location_arr"],
  components: {
    // "gmap-custom-marker": GmapCustomMarker
  },
  data() {
    return {
      mapOptions: {
        // disableDefaultUI: true,
        mapTypeId: "satellite",
        clickableIcons: false,
        gestureHandling: "cooperative",
        disableDoubleClickZoom: true,
        zoomControl: true,
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: false,
        controlSize: 24,
        zoomControlOptions: {
          position: 9,
          style: "google.maps.ZoomControlStyle.SMALL",
        },
        styles: [
          { elementType: "geometry", stylers: [{ color: "#242f3e" }] },
          {
            elementType: "labels.text.stroke",
            stylers: [{ color: "#242f3e" }],
          },
          { elementType: "labels.text.fill", stylers: [{ color: "#746855" }] },
          {
            featureType: "administrative.locality",
            elementType: "labels.text.fill",
            stylers: [{ color: "#d59563" }],
          },
          {
            featureType: "poi",
            elementType: "labels.text.fill",
            stylers: [{ color: "#d59563" }],
          },
          {
            featureType: "poi.park",
            elementType: "geometry",
            stylers: [{ color: "#263c3f" }],
          },
          {
            featureType: "poi.park",
            elementType: "labels.text.fill",
            stylers: [{ color: "#6b9a76" }],
          },
          {
            featureType: "road",
            elementType: "geometry",
            stylers: [{ color: "#38414e" }],
          },
          {
            featureType: "road",
            elementType: "geometry.stroke",
            stylers: [{ color: "#212a37" }],
          },
          {
            featureType: "road",
            elementType: "labels.text.fill",
            stylers: [{ color: "#9ca5b3" }],
          },
          {
            featureType: "road.highway",
            elementType: "geometry",
            stylers: [{ color: "#746855" }],
          },
          {
            featureType: "road.highway",
            elementType: "geometry.stroke",
            stylers: [{ color: "#1f2835" }],
          },
          {
            featureType: "road.highway",
            elementType: "labels.text.fill",
            stylers: [{ color: "#f3d19c" }],
          },
          {
            featureType: "transit",
            elementType: "geometry",
            stylers: [{ color: "#2f3948" }],
          },
          {
            featureType: "transit.station",
            elementType: "labels.text.fill",
            stylers: [{ color: "#d59563" }],
          },
          {
            featureType: "water",
            elementType: "geometry",
            stylers: [{ color: "#17263c" }],
          },
          {
            featureType: "water",
            elementType: "labels.text.fill",
            stylers: [{ color: "#515c6d" }],
          },
          {
            featureType: "water",
            elementType: "labels.text.stroke",
            stylers: [{ color: "#17263c" }],
          },
        ],
      },
      center: this.location,
      label: {
        text: "E",
        color: "White",
        fontSize: "12px",
      },
      entranceOption: {
        url: entranceMarker,
        // size: { width: 100, height: 100, f: "px", b: "px" },
        scaledSize: { width: 40, height: 50, f: "px", b: "px" },
      },
      addressOption: {
        url: locationMarker,
        // size: { width: 10, height: 10, f: "px", b: "px" },
        scaledSize: { width: 20, height: 50, f: "px", b: "px" },
      },
      addressPosition: this.location,
      entrancePosition: this.entrance_location,
      entrancePositionArr: this.entrance_location_arr,
      street_view: null,
      street_view_found: true,
    };
  },
  mounted() {
    // this.$refs.mapRef.$mapPromise.then((map) => {
    //   let panorama = map.getStreetView();
    //     panorama.addListener('visible_changed', function() {
    //         if (panorama.getVisible()) {
    //             console.log('Entering streetview');
    //         } else {
    //             console.log('Leaving streetview');
    //         }
    //     });
    // })
  },
  methods: {
    async getCoordinates(evnt, index) {
      this.entrancePositionArr[index].lat = evnt.lat();
      this.entrancePositionArr[index].lng = evnt.lng();
      let returnData = {};
      this.street_view = new window.google.maps.StreetViewService();
      const self = this;
      let myLatlng = new window.google.maps.LatLng(evnt.lat(), evnt.lng());

      await this.street_view.getPanorama(
        {
          location: myLatlng,
          radius: 100,
          source: window.google.maps.StreetViewSource.OUTDOOR,
        },
        function (data, status) {
          if (status === window.google.maps.StreetViewStatus.OK) {
            self.street_view_found = true;
            self.entrancePositionArr[index].lat = data.location.latLng.lat();
            self.entrancePositionArr[index].lng = data.location.latLng.lng();
          } else {
            self.street_view_found = false;
            self.$toasted.show(
              "No street view found! Please choose a different address",
              {
                icon: "times-circle",
                className: "error-class",
              }
            );
          }
          // console.log('1');
          returnData = {
            coordinates: self.entrancePositionArr[index],
            formatted_address: "",
            street_view_found: self.street_view_found,
            place_id: "",
            city: "",
            index: index,
          };

          const geocoder = new window.google.maps.Geocoder();
          geocoder.geocode(
            { location: self.entrancePositionArr[index] },
            function (result, status) {
              if (status == "OK") {
                if (result[0]) {
                  returnData.formatted_address = result[0].formatted_address;
                  returnData.place_id = result[0].place_id;

                  result[0].address_components.forEach((val) => {
                    if (val.types.indexOf("locality") != -1) {
                      returnData.city = val.long_name;
                    }
                  });

                  self.$emit("entrance:moved", returnData);
                } else {
                  self.$toasted.show("No address found", {
                    className: "error-class",
                    icon: "times-circle",
                    timeout: 3000,
                  });
                  return;
                }
              }
            }
          );
        }
      );
    },
    getLabel(index)
    {
      let label = JSON.parse(JSON.stringify(this.label));
      label.text = label.text+(index+1);
      return label;
      
    }
  },
};
</script>

<style>
.gm-style .gm-style-iw-t::after {
  background: #f5a623;
  box-shadow: none;
}
.gm-style .gm-style-iw-d {
  overflow: hidden !important;
  padding-right: 18px !important;
  padding-top: 18px !important;
  background-color: transparent !important;
}
.gm-ui-hover-effect {
  display: none !important;
}
.gm-style .gm-style-iw-c {
  border-radius: 0;
  padding: 0;
  box-shadow: none;
  background: transparent !important;
}
.map__height {
  height: 100%;
}
.pac-container {
  /* background-color: black; */
}
</style>